import { ColumnMappingBaseTransformPlainObject } from './columnMappingBase.plainObject';

export class SelectPlainObject extends ColumnMappingBaseTransformPlainObject {
}
